import serviceTicketPartsEditComponent from './service_ticket_parts.edit.component';

let serviceTicketPartsEditModule = angular.module('serviceTicketPartsEdit', [])

    .component('serviceTicketPartsEdit', serviceTicketPartsEditComponent)

    .name;

export default serviceTicketPartsEditModule;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/edit/index.js